<template>
<div class='container'>
	<div class='section'>
		<div id='profile-snapshot' >
			<div class='columns is-centered'>
				<div class='column is-6-desktop is-8-tablet'>	
					<div class='profile-snapshot-title profile-h1-div'>
						<p class='profile-h1' id='profile-snapshot-title'>
							In this district
						</p>
					</div>


					<div class='snapshot' id='snapshot-1'>
						<img class='snapshot-icon filter-pink-dark' src='@/assets/icon-teacher.svg' alt='Teacher by Piotrek Chuchla from the Noun Project'/>
						<div class='snapshot-text'>
							<span class='has-text-pink-dark'>{{ getVal('snapshot_staff_title', 'All') }}</span> {{ getVal('snapshot_staff_subtitle', 'All') }}
						</div>
					</div>
					<div class='snapshot' id='snapshot-2'>
						<img class='snapshot-icon filter-purple-dark' src='@/assets/icon-test.svg' alt='Test by Adrien Coquet from the Noun Project' />
						<div class='snapshot-text'>
							<span class='has-text-purple-dark'>{{ getVal('snapshot_academics_title', 'All') }}</span> {{ getVal('snapshot_academics_subtitle', 'All') }}
						</div>
					</div>
					<div class='snapshot' id='snapshot-3'>
						<img class='snapshot-icon filter-pink-darkest' src='@/assets/icon-discipline.svg' alt='Error by Deemak Daksina from the Noun Project' />
						<div class='snapshot-text'>
							<span class='has-text-pink-darkest'>{{ getVal('snapshot_discipline_title', 'All') }}</span> {{ getVal('snapshot_discipline_subtitle', 'All') }}
						</div>
					</div>
					<div class='snapshot' id='snapshot-4'>
						<img class='snapshot-icon filter-purple-darkest' src='@/assets/icon-court.svg' alt='Court by John T. Garcia from the Noun Project' />
						<div class='snapshot-text'>
							<span class='has-text-purple-darkest'>{{ getVal('snapshot_crime_title', 'All') }}</span> {{ getVal('snapshot_crime_subtitle', 'All') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

</template>

<script>

import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['activeLeaRecords'])
	},
	methods: {
		getVal(metric, subgroup) {
			// filter to just this metric
			const data = this.activeLeaRecords.filter(x => (x.metric === metric) && (x.subgroup === subgroup));

			if (data.length > 0) {
				return data[0].display_val;
			} else {
				return ''
			}
		}
	}
}

</script>